/**
 * Loyalty & Gift Cards permission keys (catalog `loyalty.*`, docs/contracts/loyalty.md §7). The API checks the same
 * keys; a manual adjustment, a gift-card void and their approval are separate (LY9, G3).
 */
export const loyaltyPermissions = {
  programmeView: "loyalty.programme.view",
  programmeCreate: "loyalty.programme.create",
  programmeUpdate: "loyalty.programme.update",
  programmeDelete: "loyalty.programme.delete",
  accountView: "loyalty.account.view",
  accountCreate: "loyalty.account.create",
  accountUpdate: "loyalty.account.update",
  accountPrint: "loyalty.account.print",
  accountAdjust: "loyalty.account.adjust",
  accountApprove: "loyalty.account.approve",
  giftCardView: "loyalty.gift_card.view",
  giftCardCreate: "loyalty.gift_card.create",
  giftCardUpdate: "loyalty.gift_card.update",
  giftCardPrint: "loyalty.gift_card.print",
  giftCardVoid: "loyalty.gift_card.void",
  giftCardRefund: "loyalty.gift_card.refund",
  giftCardApprove: "loyalty.gift_card.approve",
  discountCardView: "loyalty.discount_card.view",
  discountCardCreate: "loyalty.discount_card.create",
  discountCardUpdate: "loyalty.discount_card.update",
  discountCardDelete: "loyalty.discount_card.delete",
  discountCardPrint: "loyalty.discount_card.print",
  groupCardView: "loyalty.group_discount_card.view",
  groupCardCreate: "loyalty.group_discount_card.create",
  groupCardUpdate: "loyalty.group_discount_card.update",
  groupCardDelete: "loyalty.group_discount_card.delete",
  settingsView: "loyalty.settings.view",
  settingsUpdate: "loyalty.settings.update",
  reconciliationView: "loyalty.reconciliation.view",
  reconciliationRun: "loyalty.reconciliation.run",
  ratingView: "loyalty.customer_rating.view",
  ratingUpdate: "loyalty.customer_rating.update",
  openingCreate: "loyalty.opening.create",
} as const;

/** Plan module of Loyalty & Gift Cards. */
export const loyaltyModule = "loyalty";
